import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'batch-send-success-notification',
  templateUrl: './batch-send-success-notification.component.html',
  styleUrls: ['./batch-send-success-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchSendSuccessNotificationComponent {
  @Input() public header: string;
  @Input() public hint: string;
}
